import { makePublicUrl } from 'app/utils/publicUrl'
import SubscriptionInfo from '../SubscriptionInfo'
import { SubsDetailsPlanBlock, SubsDetailsPlanImage } from './styles'
import { SubscriptionPlanDetailsProps } from './types'

const homeDetailsImage = makePublicUrl('images/illustrations/homeDetails.svg')

function SubscriptionPlanRenewalDetails(props: SubscriptionPlanDetailsProps) {
  return (
    <SubsDetailsPlanBlock>
      <SubscriptionInfo
        isHomeDashboard={props.isHomeDashboard}
        isDetailsPage
        hasShowMore={props.hasShowMore}
        priceId={props.priceId}
        paymentMethodId={props.paymentMethodId}
        renewingStatus={props.renewingStatus}
      />
      <SubsDetailsPlanImage>
        <img src={homeDetailsImage} alt="" />
      </SubsDetailsPlanImage>
    </SubsDetailsPlanBlock>
  )
}

export default SubscriptionPlanRenewalDetails
